import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import "../../../styles/SeatPlan.scss";

interface Props {
  mapUrl?: string;
}

Modal.setAppElement("#root");

const SeatPlan: React.FC<Props> = ({ mapUrl }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  if (!mapUrl) return null;

  return (
    <>
      <div className="seat-plan" onClick={() => setIsOpen(true)}>
        <img src={mapUrl} alt="Seat Map" className="seat-map-image" />
      </div>

      <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        className="seat-map-modal"
        overlayClassName="seat-map-overlay"
        contentLabel="Seat Map Modal"
      >
        <button className="close-button" onClick={() => setIsOpen(false)}>×</button>
        <div className="zoom-container">
          <img src={mapUrl} alt="Zoomable Seat Map" className="zoomable-image" />
        </div>
      </Modal>
    </>
  );
};

export default SeatPlan;
